// src/services/monthClosePrompt.js
//
// When admins see "Close <last month>?": from the 1st of a month, while last
// month isn't closed and had something in it (goal counts or weekly reports).
// "Later" hides it for the rest of that day. Nothing closes or resets on its
// own; the admin decides (Close now, or later with the Close button as before).
// "Later" is remembered per user AND per company + site + month.
//
// Pure and Firebase-free so it is unit-tested (monthClosePrompt.test.js).

import { monthKey, shiftMonth } from "./enrollmentPeriods";
import { dayKey } from "./reportReminderSchedule";

/** The month before the one `now` is in. */
export const previousMonthId = (now = new Date()) => shiftMonth(monthKey(now), -1);

/** Show the prompt? */
export const shouldPromptClose = ({ closed, hasData, snoozedDay, now = new Date() }) =>
  !closed && !!hasData && snoozedDay !== dayKey(now);

/** localStorage key for "Later": per user, company, site and month. */
export const closePromptKey = (uid, tenantId, siteId, monthId) =>
  `regx.monthClosePrompt.v1.${uid}.${tenantId || "-"}.${siteId || "-"}.${monthId}`;

export const readSnoozedDay = (key) => {
  try {
    return window.localStorage.getItem(key) || "";
  } catch {
    return "";
  }
};

export const writeSnoozedDay = (key, now = new Date()) => {
  try {
    window.localStorage.setItem(key, dayKey(now));
  } catch {
    /* non-fatal: it just asks again */
  }
};
